import images from "common/images";
import React, { Component, PureComponent } from "react";
import { Link } from "react-router-dom";
import "./index.scss";
import iconLocation from "resources/images/current_location_pin.png";

class CustomMarker extends Component {
  shouldComponentUpdate(nextProps) {
    const { location, onHover, onLeave, currentLocation } = this.props;
    const { latitude, longitude, brand_map_image, location_map_icon } =
      location || {};
    return !!(
      latitude &&
      nextProps.location?.latitude != latitude &&
      longitude &&
      nextProps.location?.longitude != longitude
    );
  }
  render() {
    const {
      location,
      onHover,
      onLeave,
      currentLocation,
      index,
      pinMode,
      to,
    } = this.props;
    const { latitude, longitude, rgba_color, location_map_icon } =
      location || {};
    if (pinMode)
      return <img src={iconLocation} className="base-map__current-location" />;
    if (currentLocation)
      return (
        <div className="base-map__marker-container">
          <img src={iconLocation} className="base-map__current-location" />
        </div>
      );
    let isSite = false;
    let imageUrl =
      location?.brand?.brand_map_image || location?.brand?.brand_logo_image;
    if (
      location.is_current_user_brand === 1 &&
      location.site_id &&
      !location.store_id
    ) {
      isSite = true;
      imageUrl =
        location.brand.brand_site_map_image ||
        location.brand.brand_map_image ||
        location.brand.brand_logo_image;
    }
    return (
      <div className="base-map__marker-container">
        <Link to={to}>
          <img
            className="base-map__marker"
            style={{ zIndex: index }}
            src={imageUrl || location_map_icon || images.defaultCategory}
            onMouseEnter={onHover}
            onMouseLeave={onLeave}
          />
        </Link>
      </div>
    );
  }
}

export default CustomMarker;
